import { createContext, useContext, useState } from 'react';

interface DemandForecastingPairContextValue {
  productId: string;
  customerId: string;
  setProductId: (id: string) => void;
  setCustomerId: (id: string) => void;
}

export const DemandForecastingPairContext = createContext<DemandForecastingPairContextValue | null>(null);

export function DemandForecastingPairProvider({ children }: { children: React.ReactNode }) {
  const [productId, setProductId] = useState('');
  const [customerId, setCustomerId] = useState('');

  return (
    <DemandForecastingPairContext.Provider value={{ productId, customerId, setProductId, setCustomerId }}>
      {children}
    </DemandForecastingPairContext.Provider>
  );
}

export function useDemandForecastingPair() {
  const ctx = useContext(DemandForecastingPairContext);
  if (!ctx) throw new Error('useDemandForecastingPair must be used within DemandForecastingPairProvider');
  return ctx;
}
